import React from "react";

const Introduction = () => (
  <section className="container introduction">
    <h1>Front End Developer & Programmer</h1>
    <p>I design and code beautifully simple things, and I love what I do.</p>
    <img
      className="introduction__logo"
      src="logo.svg"
      alt="logo"
      height="210"
    />
    <div>
      <img className="introduction__desk" src="desk.svg" alt="me-on-working" />
    </div>
  </section>
);

export default Introduction;
